import React from 'react';
import { MapPin, ExternalLink } from 'lucide-react';

export const COLLECTION_ADDRESS = {
  line1: 'Clay Hill Farm, Clay Hill Lane',
  line2: 'Wattisham, Ipswich, Suffolk',
  postcode: 'IP7 7JS',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Clay+Hill+Farm+Clay+Hill+Lane+Wattisham+Suffolk+IP7+7JS',
};

const CollectionAddress = ({ compact = false, className = '' }) => (
  <div className={`bg-white rounded-xl border-2 border-blue-200 ${compact ? 'p-3' : 'p-4'} ${className}`} data-testid="collection-address">
    <div className="flex items-start gap-3">
      <div className="bg-blue-600 text-white rounded-lg p-2 flex-shrink-0"><MapPin className={compact ? 'h-4 w-4' : 'h-5 w-5'} /></div>
      <div className="min-w-0">
        <p className={`font-bold text-slate-900 ${compact ? 'text-sm' : ''}`}>Collection &amp; Drop-off Address</p>
        <p className={`text-slate-700 ${compact ? 'text-xs' : 'text-sm'}`}>{COLLECTION_ADDRESS.line1}, {COLLECTION_ADDRESS.line2}</p>
        <p className={`font-extrabold text-blue-700 tracking-wide ${compact ? 'text-lg' : 'text-2xl'}`}>{COLLECTION_ADDRESS.postcode}</p>
        <a href={COLLECTION_ADDRESS.mapsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-semibold text-blue-600 hover:underline mt-1" data-testid="collection-address-map-link">
          Open in Google Maps <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  </div>
);

export default CollectionAddress;
